/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { GetService } from '../../dataservices/get.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Product Tnc Component
 */
@Component({
  selector: 'app-product-tnc',
  templateUrl: './product-tnc.component.html',
  styleUrls: ['./product-tnc.component.scss']
})
export class ProductTncComponent implements OnInit, OnDestroy {

  @Input() data;

  public finished = false;
  public isSkpModalShown = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public tncContent: any;
  public msg: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public res_data: any;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    private http: HttpClient,
    private getApiService: GetService,
    public fcs: FunCollectionService,
    public multiLangService: MultiLangService,
    public Dss: DataStorageService,
    private jwtSer: JwtDecodeService) { }


  /**
   * ngOnInit
   */
  ngOnInit(): void {
    if (this.data.display_source == 'survey') {
      this.tnc();
    } else if (this.data.display_source == undefined) {
      this.channeltnc();
    }
  }

  /**
   * get Product Tnc
   */
  getProductTnc(url): void {
    this.subscriptions.add(this.http.get(url, { responseType: 'text' })
      .subscribe(data => {
        this.res_data = data;
        // console.log(this.res_data);
      }));
  }

  /**
   * tnc
   */
  tnc(): void {
    this.finished = false;
    this.subscriptions.add(this.getApiService.getTnc(this.data.safeurl).subscribe(resData => {
      this.finished = true;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          if (data.data != null) { this.tncContent = data.data.survey.tnc; } else if (data.data == null) {
            this.msg = data.msg;
          }
        } else if (data.status == 0) {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * channel tnc
   */
  channeltnc(): void {
    this.finished = false;
    this.subscriptions.add(this.getApiService.getChannelTnc(this.data.safeurl).subscribe(resData => {
      this.finished = true;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          if (data.data != null) { this.tncContent = data.data.tnc.tnc_text; } else if (data.data == null) {
            this.msg = data.msg;
          }

        } else if (data.status == 0) {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
